import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <g transform="translate(214 51)">
        <mask fill="#fff">
          <path d="M.242.065h41.516v40.831H.242z" />
        </mask>
        <path
          fill="#FFCE00"
          d="M41.758 20.48c0 11.276-9.294 20.416-20.758 20.416C9.536 40.896.242 31.756.242 20.48.242 9.205 9.536.065 21 .065c11.464 0 20.758 9.14 20.758 20.415"
          mask="url(#b)"
        />
      </g>
      <path
        fill="#1251A0"
        d="M237.359 79h-6.216v-1.568h6.216a3.077 3.077 0 0 0 3.073-3.074 3.077 3.077 0 0 0-3.073-3.074h-4.718A4.647 4.647 0 0 1 228 66.642 4.647 4.647 0 0 1 232.641 62h6.216v1.568h-6.216a3.077 3.077 0 0 0-3.073 3.074 3.077 3.077 0 0 0 3.073 3.074h4.718A4.647 4.647 0 0 1 242 74.358 4.647 4.647 0 0 1 237.359 79"
      />
      <path fill="#1251A0" d="M234 82h1V60h-1z" />
      <path fill="#50A1DA" d="M213 277h43v-43h-43z" />
      <path fill="#1663B7" d="M213 234h43v-43h-43z" />
      <path fill="#1251A0" d="M213 191h43v-43h-43zM202 148h65l-32.5-56z" />
    </g>
  </Svg>
)
